/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "b875bf8b7bfcb3372e220e16ac90d77d035b646c";
